//diverging
//
// Reversed from the colorcet default because that had Blue to the left
// colorcet.CET_D9[::-1]

export const DIVERGING_RED_WHITE_BLUE = [
    "#e65036",
    "#e65138",
    "#e75339",
    "#e7553a",
    "#e8563c",
    "#e8583d",
    "#e9593f",
    "#e95b40",
    "#e95c41",
    "#ea5e43",
    "#ea5f44",
    "#eb6046",
    "#eb6247",
    "#ec6349",
    "#ec654a",
    "#ec664b",
    "#ed684d",
    "#ed694e",
    "#ee6a50",
    "#ee6c51",
    "#ee6d52",
    "#ef6f54",
    "#ef7055",
    "#ef7157",
    "#f07358",
    "#f0745a",
    "#f1765b",
    "#f1775d",
    "#f1785e",
    "#f27a5f",
    "#f27b61",
    "#f27c62",
    "#f37e64",
    "#f37f65",
    "#f38067",
    "#f48268",
    "#f4836a",
    "#f4846b",
    "#f5866c",
    "#f5876e",
    "#f5886f",
    "#f58a71",
    "#f68b72",
    "#f68c74",
    "#f68d75",
    "#f78f77",
    "#f79078",
    "#f7917a",
    "#f7937b",
    "#f8947d",
    "#f8957e",
    "#f89780",
    "#f89881",
    "#f99983",
    "#f99a84",
    "#f99c86",
    "#f99d87",
    "#f99e89",
    "#faa08a",
    "#faa18c",
    "#faa28d",
    "#faa38f",
    "#faa590",
    "#fba692",
    "#fba793",
    "#fba995",
    "#fbaa96",
    "#fbab98",
    "#fbac99",
    "#fcae9b",
    "#fcaf9c",
    "#fcb09e",
    "#fcb19f",
    "#fcb3a1",
    "#fcb4a2",
    "#fcb5a4",
    "#fcb7a5",
    "#fdb8a7",
    "#fdb9a8",
    "#fdbaaa",
    "#fdbcac",
    "#fdbdad",
    "#fdbeaf",
    "#fdbfb0",
    "#fdc1b2",
    "#fdc2b3",
    "#fdc3b5",
    "#fdc4b6",
    "#fdc6b8",
    "#fdc7ba",
    "#fdc8bb",
    "#fdcabd",
    "#fdcbbe",
    "#fdccc0",
    "#fdcdc1",
    "#fdcfc3",
    "#fdd0c5",
    "#fdd1c6",
    "#fdd2c8",
    "#fdd4c9",
    "#fdd5cb",
    "#fdd6cc",
    "#fdd7ce",
    "#fdd9d0",
    "#fddad1",
    "#fddbd3",
    "#fddcd4",
    "#fdded6",
    "#fcdfd8",
    "#fce0d9",
    "#fce1db",
    "#fce3dc",
    "#fce4de",
    "#fce5e0",
    "#fce7e1",
    "#fce8e3",
    "#fbe9e5",
    "#fbeae6",
    "#fbece8",
    "#fbede9",
    "#fbeeeb",
    "#faefed",
    "#faf1ee",
    "#faf2f0",
    "#faf3f2",
    "#f9f4f3",
    "#f9f5f5",
    "#f8f6f6",
    "#f7f6f7",
    "#f6f6f8",
    "#f5f5f9",
    "#f4f4f9",
    "#f3f3f9",
    "#f1f2f9",
    "#f0f1f9",
    "#eff0f9",
    "#eeeffa",
    "#edeefa",
    "#ecedfa",
    "#eaecfa",
    "#e9ebfa",
    "#e8eafa",
    "#e7e9fa",
    "#e6e8fa",
    "#e5e7fa",
    "#e3e6fa",
    "#e2e5fa",
    "#e1e4fa",
    "#e0e3fa",
    "#dfe2fb",
    "#dde1fb",
    "#dce0fb",
    "#dbdffb",
    "#dadefb",
    "#d9ddfb",
    "#d7dcfb",
    "#d6dbfb",
    "#d5dafb",
    "#d4d9fb",
    "#d3d8fb",
    "#d1d7fb",
    "#d0d6fb",
    "#cfd5fb",
    "#ced4fb",
    "#cdd3fc",
    "#cbd2fc",
    "#cad1fc",
    "#c9d0fc",
    "#c8cffc",
    "#c6cefc",
    "#c5cdfc",
    "#c4ccfc",
    "#c3cbfc",
    "#c1cafc",
    "#c0c9fc",
    "#bfc8fc",
    "#bdc7fc",
    "#bcc7fc",
    "#bbc6fc",
    "#bac5fc",
    "#b8c4fc",
    "#b7c3fc",
    "#b6c2fc",
    "#b4c1fd",
    "#b3c0fd",
    "#b2bffd",
    "#b0befd",
    "#afbdfd",
    "#aebcfd",
    "#acbbfd",
    "#abbafd",
    "#aab9fd",
    "#a8b8fd",
    "#a7b7fd",
    "#a5b6fd",
    "#a4b5fd",
    "#a3b4fd",
    "#a1b3fd",
    "#a0b2fd",
    "#9eb2fd",
    "#9db1fd",
    "#9bb0fd",
    "#9aaffd",
    "#99aefd",
    "#97adfd",
    "#96acfd",
    "#94abfd",
    "#93aafd",
    "#91a9fd",
    "#90a8fd",
    "#8ea7fd",
    "#8ca6fd",
    "#8ba5fe",
    "#89a4fe",
    "#88a4fe",
    "#86a3fe",
    "#84a2fe",
    "#83a1fe",
    "#81a0fe",
    "#809ffe",
    "#7e9efe",
    "#7c9dfe",
    "#7a9cfe",
    "#799bfe",
    "#779afe",
    "#759afe",
    "#7399fe",
    "#7198fe",
    "#7097fe",
    "#6e96fe",
    "#6c95fe",
    "#6a94fe",
    "#6893fe",
    "#6692fe",
    "#6491fe",
    "#6291fe",
    "#5f90fe",
    "#5d8ffe",
    "#5b8efe",
    "#598dfe",
    "#568cfe",
    "#548bfe",
    "#518afe",
    "#4f8afe",
    "#4c89fe",
    "#4988fe",
    "#4787fe",
    "#4486fe",
    "#4085fe",
    "#3d84fe",
    "#3a83fe",
    "#3683fe",
    "#3282fe",
    "#2e81fe",
    "#2980fe",
    "#247ffe",
];

//colorcet.CET_CBD2
export const BLUE_TO_YELLOW = [
    "#0488fc",
    "#1089fb",
    "#1789fb",
    "#1d89fa",
    "#228afa",
    "#268af9",
    "#2a8af9",
    "#2e8af8",
    "#318bf7",
    "#348bf7",
    "#378bf6",
    "#3a8cf6",
    "#3c8cf5",
    "#3f8cf5",
    "#418df4",
    "#438df4",
    "#458df3",
    "#488df2",
    "#4a8ef2",
    "#4c8ef1",
    "#4d8ef1",
    "#4f8ff0",
    "#518ff0",
    "#538fef",
    "#5490ee",
    "#5690ee",
    "#5890ed",
    "#5991ed",
    "#5b91ec",
    "#5c91ec",
    "#5e92eb",
    "#5f92ea",
    "#6192ea",
    "#6292e9",
    "#6393e9",
    "#6593e8",
    "#6693e8",
    "#6794e7",
    "#6994e6",
    "#6a94e6",
    "#6b95e5",
    "#6c95e5",
    "#6e95e4",
    "#6f96e4",
    "#7096e3",
    "#7196e3",
    "#7297e2",
    "#7397e1",
    "#7497e1",
    "#7698e0",
    "#7798e0",
    "#7898df",
    "#7999df",
    "#7a99de",
    "#7b99dd",
    "#7c9add",
    "#7d9adc",
    "#7e9adc",
    "#7f9bdb",
    "#809bdb",
    "#819bda",
    "#829cd9",
    "#839cd9",
    "#849cd8",
    "#849dd8",
    "#859dd7",
    "#869dd7",
    "#879ed6",
    "#889ed5",
    "#899ed5",
    "#8a9fd4",
    "#8b9fd4",
    "#8c9fd3",
    "#8ca0d3",
    "#8da0d2",
    "#8ea0d1",
    "#8fa1d1",
    "#90a1d0",
    "#91a1d0",
    "#91a2cf",
    "#92a2ce",
    "#93a2ce",
    "#94a3cd",
    "#95a3cd",
    "#95a3cc",
    "#96a4cc",
    "#97a4cb",
    "#98a4ca",
    "#98a5ca",
    "#99a5c9",
    "#9aa5c9",
    "#9ba6c8",
    "#9ba6c8",
    "#9ca6c7",
    "#9da7c6",
    "#9ea7c6",
    "#9ea7c5",
    "#9fa8c5",
    "#a0a8c4",
    "#a0a9c3",
    "#a1a9c3",
    "#a2a9c2",
    "#a2aac2",
    "#a3aac1",
    "#a4aac1",
    "#a4abc0",
    "#a5abbf",
    "#a6abbf",
    "#a6acbe",
    "#a7acbe",
    "#a8acbd",
    "#a8adbc",
    "#a9adbc",
    "#aaadbb",
    "#aaaebb",
    "#abaeba",
    "#acafb9",
    "#acafb9",
    "#adafb8",
    "#adb0b8",
    "#aeb0b7",
    "#afb0b7",
    "#afb1b6",
    "#b0b1b5",
    "#b1b1b5",
    "#b1b2b4",
    "#b2b2b4",
    "#b2b2b3",
    "#b3b3b2",
    "#b4b3b2",
    "#b4b3b1",
    "#b5b4b1",
    "#b6b4b0",
    "#b7b4af",
    "#b7b5af",
    "#b8b5ae",
    "#b9b5ad",
    "#bab6ad",
    "#bab6ac",
    "#bbb6ac",
    "#bcb7ab",
    "#bcb7aa",
    "#bdb7aa",
    "#beb8a9",
    "#beb8a8",
    "#bfb8a8",
    "#c0b9a7",
    "#c0b9a7",
    "#c1b9a6",
    "#c2baa5",
    "#c2baa5",
    "#c3baa4",
    "#c4bba3",
    "#c4bba3",
    "#c5bba2",
    "#c6bca2",
    "#c6bca1",
    "#c7bca0",
    "#c8bca0",
    "#c8bd9f",
    "#c9bd9e",
    "#cabd9e",
    "#cabe9d",
    "#cbbe9c",
    "#ccbe9c",
    "#ccbf9b",
    "#cdbf9b",
    "#cdbf9a",
    "#cec099",
    "#cfc099",
    "#cfc098",
    "#d0c197",
    "#d1c197",
    "#d1c196",
    "#d2c295",
    "#d2c295",
    "#d3c294",
    "#d4c393",
    "#d4c393",
    "#d5c392",
    "#d5c491",
    "#d6c491",
    "#d7c490",
    "#d7c58f",
    "#d8c58f",
    "#d8c58e",
    "#d9c68d",
    "#dac68d",
    "#dac68c",
    "#dbc78b",
    "#dbc78b",
    "#dcc78a",
    "#dcc889",
    "#ddc889",
    "#dec888",
    "#dec987",
    "#dfc987",
    "#dfc986",
    "#e0ca85",
    "#e0ca85",
    "#e1ca84",
    "#e2cb83",
    "#e2cb83",
    "#e3cc82",
    "#e3cc81",
    "#e4cc80",
    "#e4cd80",
    "#e5cd7f",
    "#e6cd7e",
    "#e6ce7e",
    "#e7ce7d",
    "#e7ce7c",
    "#e8cf7b",
    "#e8cf7b",
    "#e9cf7a",
    "#e9d079",
    "#ead078",
    "#ead078",
    "#ebd177",
    "#ecd176",
    "#ecd176",
    "#edd275",
    "#edd274",
    "#eed273",
    "#eed373",
    "#efd372",
    "#efd371",
    "#f0d470",
    "#f0d46f",
    "#f1d46f",
    "#f1d56e",
    "#f2d56d",
    "#f2d56c",
    "#f3d66c",
    "#f3d66b",
    "#f4d66a",
    "#f5d769",
    "#f5d768",
    "#f6d868",
    "#f6d867",
    "#f7d866",
    "#f7d965",
    "#f8d964",
    "#f8d963",
    "#f9da63",
    "#f9da62",
    "#fada61",
    "#fadb60",
    "#fbdb5f",
    "#fbdb5e",
    "#fcdc5d",
    "#fcdc5d",
    "#fddc5c",
    "#fddd5b",
    "#fedd5a",
    "#fedd59",
];
